import { render } from "./FishHomeView.vue?vue&type=template&id=43ccfdd6"
import script from "./FishHomeView.vue?vue&type=script&lang=js"
export * from "./FishHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__